import React from 'react'

import { pushEventData } from '../../../utils/pushEventDataLayer'

import './menuSection.scss'

const MenuSection = () => {
  const NAV_OPTIONS = ['Tarjetas', 'Stickers', 'Wallpapers']

  const formatOption = option =>
    option
      .normalize('NFD')
      .toLowerCase()
      .replace(/\s/g, '0')
      .replace(/[\u0300-\u036f]|\W/gim, '')
      .replace(/0/g, '-')

  return (
    <aside className="f-menuSection-container">
      <nav>
        <ul>
          {NAV_OPTIONS.map((option, index) => {
            let optionFormated = formatOption(option)

            return (
              <li key={index} className="">
                <a
                  href={`#${optionFormated}`}
                  className={`f-${optionFormated}`}
                  onClick={() =>
                    pushEventData({
                      event: 'Interacciones_Menu_Navidad',
                      category: 'Navidad',
                      action: 'click',
                      label: option,
                    })
                  }
                >
                  {option}
                </a>
              </li>
            )
          })}
        </ul>
      </nav>
    </aside>
  )
}

export default MenuSection
